import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import {
  DividerFill, DividerOrientation, DividerType, DividerWidth
} from '@design-system/components/atoms/divider/entities/divider.types';

@Component({
  selector: 'app-ds-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class DividerDsComponent {

  @Input() type = DividerType.Primary;
  @Input() fill = DividerFill.Solid;
  @Input() orientation = DividerOrientation.Horizontal;
  @Input() width = DividerWidth.Default;

  constructor() { }

}
